import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import {mergeMap, retryWhen, tap} from 'rxjs/operators';
import {throwError} from 'rxjs/internal/observable/throwError';
import {timer} from 'rxjs/internal/observable/timer';

@Injectable()
export class HttpInterceptor implements HttpInterceptor {

  private readonly MAX_RETRY_ATTEMPTS = 3;

  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
        retryWhen((attempts: Observable<any>) => {
          return attempts.pipe(
              mergeMap((error, i) => {
                if (i + 1 > this.MAX_RETRY_ATTEMPTS || this.shouldntRetry(error)) {
                  return throwError(error);
                }
                return timer(0);
              }),
          );
        })
    );
  }

  private shouldntRetry(error: any): boolean {
    if (error.hasOwnProperty('error')) {
      const { status, message } = error.error;
      return status === 403 && message === 'CALCULATION_UNAVAILABLE';
    }
    return false;
  }
}
